var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6725 2.65988C23.3944 1.61292 22.5751 0.788302 21.5349 0.508418C19.6494 2.00502e-07 12.0889 0 12.0889 0C12.0889 0 4.52829 2.00502e-07 2.64274 0.50847C1.60252 0.788355 0.783256 1.61292 0.505211 2.65993C-5.01256e-08 4.55762 0 8.51716 0 8.51716C0 8.51716 -5.01256e-08 12.4768 0.505211 14.3744C0.783256 15.4214 1.60252 16.2116 2.64274 16.4916C4.52829 17 12.0889 17 12.0889 17C12.0889 17 19.6494 17 21.5349 16.4915C22.5751 16.2116 23.3944 15.4213 23.6725 14.3743C24.1777 12.4767 24.1777 8.51711 24.1777 8.51711C24.1777 8.51711 24.1777 4.55762 23.6725 2.65988Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61597 12.1118V4.92188L15.9351 8.51691L9.61597 12.1118Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtubeLogo.45bd940d994531174d9826aa91e4eb77.svg";
export { ForwardRef as ReactComponent };